import { Menu, ScrollArea } from "@mantine/core";
import Icon                 from "_components/atoms/icon";

const component = ( {
	qualities,
	setQuality,
	currQuality,
	onClose
} ) => {

	return (

		<ScrollArea>
			{
				qualities.map ( item => {
					if ( !item )
						return null;

					return (
						<Menu.Item
							key = { item }
							onClick = { () => {
								setQuality ( item );
								onClose ();
							} }
							rightSection = { item === currQuality ? (
								<Icon sameInBothTheme
									name = "checkmark"
									size = "15px"
								/>
							) : null }
							selected = { item?.name === currQuality }
						>

							<span>
								{ item + "p" }
							</span>

						</Menu.Item>
					);

				} )
			}

			<Menu.Item
				onClick = { () => {
					setQuality ( "auto" );
					onClose ();
				} }
				rightSection = { currQuality === "auto" ? (
					<Icon sameInBothTheme
						name = "checkmark"
						size = "15px"
					/>
				)
					: null }
				selected = { currQuality === "auto" }
			>

				<span>
					Auto
				</span>

			</Menu.Item>
		</ScrollArea>
	);
};

export default component;
